<template>
  <div class="form-group">
    <label class="label">{{ title }}</label>

    <template v-for="(item, index) in modelItems">
      <div :key="index + '.InputRow'" class="row form-group">
        <div class="col-12">
          <w-input
            :model="item.model"
            :disabled="checkAllProperty(item, 'disabled')"
            :show-error="checkAllProperty(item, 'showError')"
            :placeholder="item.placeholder"
            :type="checkAllProperty(item, 'type')"
            :appendicon="item.appendicon"
            :prependicon="item.prependicon"
            :set-title-as-placeholder="checkAllProperty(item, 'setTitleAsPlaceholder')"
            :tooltip="item.tooltip"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';

// @vuese
// Input row component
// // @Group detailsComponents
export default {
  mixins: [componentMixin],
  props: {
    // Przekazuje tablicę z elementami takimi jak disabled, showError
    allParametrs: { type: Object, required: false }
  },
  methods: {
    // @vuese
    // Zwraca podane property lub property `all`
    checkAllProperty(item, property) {
      return (this.allParametrs && this.allParametrs[property]) || item[property];
    }
  }
};
</script>
